import styles from "../styles.module.scss";
import ButtonOption from "../ButtonOption";
import {useAppData} from "../../context/Contexts";
import {
    formatMoney,
    formatShopifyMoney,
    formatSelectedSeat, getCompareOfferPrice,
    getCurrency, getOfferPrice, getPriceElem,
    isCustom,
    isCustomFront,
    isCustomFrontJump, isCustomJump,
    isCustomThreeRows, parsedSeatUserFriendly
} from "../../helpers/helpers";
import React, {useState, useEffect, useRef} from "react";
import fetchCheck from "../../services/CheckService";
import SuperOffer from "../SuperOffer";
import ButtonOptionNew from "../ButtonOptionNew";
import Slider from "react-slick";

function isPetCoverUpsell(upsell: any): boolean {
    return upsell?.title?.toLowerCase().includes('pet');
}

function getEffectivePetCoverVariant(upsell: any, vehicleType: string | undefined): any {
    if (!isPetCoverUpsell(upsell) || !upsell?.variants || upsell.variants.length <= 1) {
        return upsell?.variants?.[0];
    }
    const isTruck = vehicleType === 'Truck';
    const truckVariant = upsell.variants.find((v: any) => v.title?.toLowerCase().includes('truck'));
    const carVariant = upsell.variants.find((v: any) =>
        v.title?.toLowerCase().includes('car') || v.title?.toLowerCase().includes('suv')
    );
    if (isTruck && truckVariant) return truckVariant;
    if (!isTruck && carVariant) return carVariant;
    return upsell.variants[0];
}

export default function StepUpsells(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const sliderRef1 = useRef(null);
    const [slider1, setSlider1] = useState(null);

    const handleChange = (e) => {

        const currentValue = e.target.getAttribute("id").replace('addon_', '');
        let new_value = currentAppData?.addons;

        if (!currentAppData?.addons) {
            new_value = currentValue;
        } else {

            const parts = new_value?.split(',');
            const isChecked = e.target.checked;

            if (isChecked) {
                parts?.push(currentValue);
                new_value = parts?.filter(v => v.trim() != '').join(',');
            } else {
                const index = parts?.indexOf(currentValue);
                // console.log('index', index);
                if (index != undefined && index !== -1) {
                    const x = parts.splice(index + 1, 1).filter(v => v.trim() != '');
                    // console.log('new_value x', x);
                    new_value = x.join(',');
                }
            }
        }

        // console.log('handleAddonChange', new_value);

        setCurrentAppData(prevState => {
            return {...prevState, addons: new_value}
        })
    }

    const sliderSettings = {
        centerMode: false,
        slidesToShow: 1,
        vertical: false,
        verticalSwiping: true,
        arrows: true,
        dots: true,
        swipeToSlide: true,
        focusOnSelect: true,
        className: "slider-nav-upsells",
        asNavFor: null,
        prevArrow: (
            <button type="button" className="slick-prev slick-arrow" aria-label="Previous upsell">
                Previous
            </button>
        ),
        nextArrow: (
            <button type="button" className="slick-next slick-arrow" aria-label="Next upsell">
                Next
            </button>
        ),
    };

    return (<>

        <>
            <section
                className={`${styles.section__step} ${window.scs_new_design_2026 ? styles.scs_new_design_2026 : ''}`}
                id="step_upsells">

                <div className={`${styles.upsells_wrapper}`}>

                    <div className={`${styles.upsells}`}>
                        <Slider
                            ref={(slider) => setSlider1(slider)}
                            {...sliderSettings}
                        >
                        {window.scs_upsells.map((el, idx) => {
                            const rand = 39;
                            const discountRaw = (window.scs_upsells_sale_prices || '').split(',')[idx]?.trim();
                            const discount = discountRaw && discountRaw !== '' ? parseFloat(discountRaw) : 0;
                            const hasDiscount = discount > 0;

                            const vehicleType = currentAppData?.check?.vehicle_type;
                            const effectiveVariant = getEffectivePetCoverVariant(el, vehicleType);

                            const normalPrice = effectiveVariant.price / 100;

                            const comparePrice = hasDiscount
                                ? normalPrice.toFixed(2)
                                : ((effectiveVariant.compare_at_price ?
                                    effectiveVariant.compare_at_price / 100 :
                                    (normalPrice * ((100 + rand) / 100))))
                                    .toFixed(2);

                            const displayPrice = hasDiscount
                                ? normalPrice - discount
                                : normalPrice;

                            const id = effectiveVariant.id;
                            const isPetCoverChecked = isPetCoverUpsell(el)
                                ? el.variants.some((v: any) => currentAppData?.addons?.includes(`${v.id}`))
                                : currentAppData?.addons?.includes(`${id}`);

                            return (<div key={`upsell-${el.variants[0].id}`} id={`upsell-${el.variants[0].id}`} className={`${styles.upsell}`}>
                                <ButtonOptionNew key={`key-${id}`}
                                                 img={el.images[0]}
                                                 comparePrice={formatShopifyMoney(parseFloat(comparePrice))}
                                                 price={formatShopifyMoney(displayPrice)}
                                                 showSavingsIcon={false}
                                                 value={`${el.title}`}
                                                 id={`addon_${id}`}
                                                 name="addons[]"
                                                 onChange={handleChange}
                                                 customClass={styles.ultimate_upgrade}
                                                 display={true}
                                                 enabled={true}
                                                 type={'checkbox'}
                                                 diffPrefix={hasDiscount ? `` : ''}
                                                 diffSuffix={hasDiscount ? ' OFF' : '% OFF'}
                                                 showPercentage={!hasDiscount}
                                                 checked={isPetCoverChecked}

                                /></div>);
                        })}
                        </Slider>
                    </div>


                </div>

            </section>

        </>
    </>);
}